/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.198.0-v202609241235-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqAgentsApiClass {
 
   constructor() {}

  /**
   * @summary Archive an agent
   * @param {string} agentName - The name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
  */
  public archiveAgent(
    {
      agentName
    } : {
      agentName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a connection
   * @param {string} agentName - The name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - The name of the connector. The connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
   * @param {string} connectionName - The name of the connection. The connection name can be obtained from the &#x27;Connections&#x27; array in the response of &#x27;GET /agents/{agentName}/connectors/{connectorName}&#x27;
  */
  public archiveConnection(
    {
      agentName,
      connectorName,
      connectionName
    } : {
      agentName: string,
      connectorName: string,
      connectionName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }

    if (connectionName === null || connectionName === undefined) {
      throw new Error("'connectionName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)))
      .replace('{connectionName}', encodeURIComponent(String(connectionName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a connector
   * @param {string} agentName - The name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - The name of the connector. The connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
  */
  public archiveConnector(
    {
      agentName,
      connectorName
    } : {
      agentName: string,
      connectorName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get the Run and Staged Versions for this instance and a sorted list of available installers
  */
  public configuredDirectives(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/remote-updates/configuredDirectives`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConfiguredDirectivesOutputV1>;
  }

  /**
   * @summary Create or update an agent
   * @param {string} agentName - Name of the agent to create or update. For update, the name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
  */
  public createOrUpdateAgent(
    body: models.AgentInputV1,
    {
      agentName
    } : {
      agentName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AgentOutputV1>;
  }

  /**
   * @summary Create or update a connection
   * @param {string} agentName - Name of the agent where the connector resides. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector where the connection resides. The connector name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors&#x27;
   * @param {string} connectionName - Name of the connection to create or update. For update, the connection name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors/{connectorName}/connections&#x27;
  */
  public createOrUpdateConnection(
    body: models.ConnectionInputV1,
    {
      agentName,
      connectorName,
      connectionName
    } : {
      agentName: string,
      connectorName: string,
      connectionName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }

    if (connectionName === null || connectionName === undefined) {
      throw new Error("'connectionName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)))
      .replace('{connectionName}', encodeURIComponent(String(connectionName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConnectionOutputV1>;
  }

  /**
   * @summary Create or update a connector
   * @param {string} agentName - Name of the agent where connector resides. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector to create or update. For update, the connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
  */
  public createOrUpdateConnector(
    body: models.ConnectorInputV1,
    {
      agentName,
      connectorName
    } : {
      agentName: string,
      connectorName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConnectorOutputV1>;
  }

  /**
   * @summary Delete a stored secret for a connection. Note that this does not restart the connection, which may be necessary for it to detect the secret change.
   * @param {string} agentName - Name of the agent where the connector resides. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector where the connection resides. The connector name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors&#x27;
   * @param {string} connectionName - Name of the connection from which to delete secret. The connection name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors/{connectorName}/connections&#x27;
   * @param {string} secret - Name of the secret to delete
  */
  public deleteSecretForConnection(
    {
      agentName,
      connectorName,
      connectionName,
      secret
    } : {
      agentName: string,
      connectorName: string,
      connectionName: string,
      secret: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }

    if (connectionName === null || connectionName === undefined) {
      throw new Error("'connectionName' parameter required");
    }

    if (secret === null || secret === undefined) {
      throw new Error("'secret' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}/secrets/${encodeURIComponent(String(secret))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)))
      .replace('{connectionName}', encodeURIComponent(String(connectionName)))
      .replace('{secret}', encodeURIComponent(String(secret)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get an agent and its configuration
   * @param {string} agentName - Name of the agent to get. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
  */
  public getAgent(
    {
      agentName
    } : {
      agentName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.AgentOutputV1>;
  }

  /**
   * @summary Get the status of every connection in every agent that the user has access to
  */
  public getAgentStatus(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/status`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<Array<models.AgentStatusV1>>;
  }

  /**
   * @summary Get a connection and its configuration
   * @param {string} agentName - Name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector to get. The connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
   * @param {string} connectionName - Name of the connection to get. The connection name can be obtained from the &#x27;Connections&#x27; array in the response of &#x27;GET /agents/{agentName}/connectors/{connectorName}&#x27;
  */
  public getConnection(
    {
      agentName,
      connectorName,
      connectionName
    } : {
      agentName: string,
      connectorName: string,
      connectionName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }

    if (connectionName === null || connectionName === undefined) {
      throw new Error("'connectionName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)))
      .replace('{connectionName}', encodeURIComponent(String(connectionName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConnectionOutputV1>;
  }

  /**
   * @summary Gets the configuration of all connections of a connector
   * @param {string} agentName - Name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status/{detailsLevel}
   * @param {string} connectorName - Name of the connector. The connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET /agents/{agentName}&#x27;
  */
  public getConnections(
    {
      agentName,
      connectorName
    } : {
      agentName: string,
      connectorName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConnectionsOutputV1>;
  }

  /**
   * @summary Get a connector and its configuration
   * @param {string} agentName - Name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector to get. The connector name can be obtained from the &#x27;Connectors&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
  */
  public getConnector(
    {
      agentName,
      connectorName
    } : {
      agentName: string,
      connectorName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConnectorOutputV1>;
  }

  /**
   * @summary Gets the configuration of all connectors hosted by an agent
   * @param {string} agentName - Name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
  */
  public getConnectors(
    {
      agentName
    } : {
      agentName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors`
      .replace('{agentName}', encodeURIComponent(String(agentName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ConnectorsOutputV1>;
  }

  /**
   * @summary Get the status of every connection for every datasource that the user has access to
  */
  public getDatasourcesStatus(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/datasources-status`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.DatasourcesStatusOutputV1>;
  }

  /**
   * @summary Get update directives for the remote agent
   * @param {string} machineName - Name of the remote agent machine to get update directives
  */
  public getRemoteUpdateDirectives(
    {
      machineName
    } : {
      machineName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (machineName === null || machineName === undefined) {
      throw new Error("'machineName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/remote-updates/${encodeURIComponent(String(machineName))}/directives`
      .replace('{machineName}', encodeURIComponent(String(machineName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.RemoteAgentDirectivesOutputV1>;
  }

  /**
   * @summary Request indexing of the given datasource.
   * @param {string} datasourceClass - Datasource class of the connection
   * @param {string} datasourceId - Datasource ID of the connection
  */
  public index(
    body: models.IndexingParametersInputV1,
    {
      datasourceClass,
      datasourceId
    } : {
      datasourceClass: string,
      datasourceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/index`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Post the status of every connection in an agent
  */
  public postAgentStatus(
    body: models.AgentStatusV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/status`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Pre-provision the user for an agent
  */
  public preProvision(
    body: models.PreProvisionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/pre-provision`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.PreProvisionOutputV1>;
  }

  /**
   * @summary Finish the user provisioning for an agent.
  */
  public provision(
    body: models.ProvisionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/provision`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Restart an agent
   * @param {string} agentName - Name of the agent to restart. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
  */
  public restartAgent(
    {
      agentName
    } : {
      agentName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/restart`
      .replace('{agentName}', encodeURIComponent(String(agentName)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Restart a connector
   * @param {string} agentName - Name of the agent. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector to restart. The connector name can be obtained from the &#x27;Connector&#x27; array in the response of &#x27;GET / agents / {agentName}&#x27;
  */
  public restartConnector(
    {
      agentName,
      connectorName
    } : {
      agentName: string,
      connectorName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/restart`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Store a secret for a connection. Note that this does not restart the connection, which may be necessary for it to detect the secret change.
   * @param {string} agentName - Name of the agent where the connector resides. The name of the agent can be obtained from the result of GET /agents/status or from the result of GET /agents/datasources-status
   * @param {string} connectorName - Name of the connector where the connection resides. The connector name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors&#x27;
   * @param {string} connectionName - Name of the connection to which to store secret. The connection name can be obtained from the result of &#x27;GET /agents/{agentName}/connectors/{connectorName}/connections&#x27;
  */
  public storeSecretForConnection(
    body: models.StoreSecretInputV1,
    {
      agentName,
      connectorName,
      connectionName
    } : {
      agentName: string,
      connectorName: string,
      connectionName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (agentName === null || agentName === undefined) {
      throw new Error("'agentName' parameter required");
    }

    if (connectorName === null || connectorName === undefined) {
      throw new Error("'connectorName' parameter required");
    }

    if (connectionName === null || connectionName === undefined) {
      throw new Error("'connectionName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}/secrets`
      .replace('{agentName}', encodeURIComponent(String(agentName)))
      .replace('{connectorName}', encodeURIComponent(String(connectorName)))
      .replace('{connectionName}', encodeURIComponent(String(connectionName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Writes remote update directive config option and sets last updated timestamp
  */
  public updateDirective(
    body: models.DirectiveInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/remote-updates/updateDirective`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create or update status of an agent-machine for remote-updates
   * @param {string} machineName - Name of the remote agent machine to create or update with new status
  */
  public updateRemoteAgentStatus(
    body: models.RemoteAgentStatusInputV1,
    {
      machineName
    } : {
      machineName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (machineName === null || machineName === undefined) {
      throw new Error("'machineName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/agents/remote-updates/${encodeURIComponent(String(machineName))}/status`
      .replace('{machineName}', encodeURIComponent(String(machineName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.RemoteAgentStatusOutputV1>;
  }

}


export const sqAgentsApi = new sqAgentsApiClass();

export type sqAgentsApiEndpoints = {
  'archiveAgent': {
    method: 'delete';
    path: '/agents/${encodeURIComponent(String(agentName))}';
    response: models.StatusMessageBase;
  };
  'archiveConnection': {
    method: 'delete';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}';
    response: models.StatusMessageBase;
  };
  'archiveConnector': {
    method: 'delete';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}';
    response: models.StatusMessageBase;
  };
  'configuredDirectives': {
    method: 'get';
    path: '/agents/remote-updates/configuredDirectives';
    response: models.ConfiguredDirectivesOutputV1;
  };
  'createOrUpdateAgent': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}';
    response: models.AgentOutputV1;
  };
  'createOrUpdateConnection': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}';
    response: models.ConnectionOutputV1;
  };
  'createOrUpdateConnector': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}';
    response: models.ConnectorOutputV1;
  };
  'deleteSecretForConnection': {
    method: 'delete';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}/secrets/${encodeURIComponent(String(secret))}';
    response: models.StatusMessageBase;
  };
  'getAgent': {
    method: 'get';
    path: '/agents/${encodeURIComponent(String(agentName))}';
    response: models.AgentOutputV1;
  };
  'getAgentStatus': {
    method: 'get';
    path: '/agents/status';
    response: Array<models.AgentStatusV1>;
  };
  'getConnection': {
    method: 'get';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}';
    response: models.ConnectionOutputV1;
  };
  'getConnections': {
    method: 'get';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections';
    response: models.ConnectionsOutputV1;
  };
  'getConnector': {
    method: 'get';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}';
    response: models.ConnectorOutputV1;
  };
  'getConnectors': {
    method: 'get';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors';
    response: models.ConnectorsOutputV1;
  };
  'getDatasourcesStatus': {
    method: 'get';
    path: '/agents/datasources-status';
    response: models.DatasourcesStatusOutputV1;
  };
  'getRemoteUpdateDirectives': {
    method: 'get';
    path: '/agents/remote-updates/${encodeURIComponent(String(machineName))}/directives';
    response: models.RemoteAgentDirectivesOutputV1;
  };
  'index': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/index';
    response: models.StatusMessageBase;
  };
  'postAgentStatus': {
    method: 'post';
    path: '/agents/status';
    response: models.StatusMessageBase;
  };
  'preProvision': {
    method: 'post';
    path: '/agents/pre-provision';
    response: models.PreProvisionOutputV1;
  };
  'provision': {
    method: 'post';
    path: '/agents/provision';
    response: models.StatusMessageBase;
  };
  'restartAgent': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}/restart';
    response: models.StatusMessageBase;
  };
  'restartConnector': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/restart';
    response: models.StatusMessageBase;
  };
  'storeSecretForConnection': {
    method: 'post';
    path: '/agents/${encodeURIComponent(String(agentName))}/connectors/${encodeURIComponent(String(connectorName))}/connections/${encodeURIComponent(String(connectionName))}/secrets';
    response: models.StatusMessageBase;
  };
  'updateDirective': {
    method: 'post';
    path: '/agents/remote-updates/updateDirective';
    response: models.StatusMessageBase;
  };
  'updateRemoteAgentStatus': {
    method: 'post';
    path: '/agents/remote-updates/${encodeURIComponent(String(machineName))}/status';
    response: models.RemoteAgentStatusOutputV1;
  };
};

type ApiArchiveAgentResponse = models.StatusMessageBase;
type ApiarchiveAgentMutationParams = Parameters<typeof sqAgentsApi.archiveAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.archiveAgent>;

export function useApiArchiveAgentMutation(
  options?: Omit<UseMutationOptions<ApiArchiveAgentResponse, AxiosError<SeeqErrorData>,
    ApiarchiveAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveAgentResponse, AxiosError<SeeqErrorData>,
  ApiarchiveAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveAgentMutationParams) =>
      sqAgentsApi.archiveAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveConnectionResponse = models.StatusMessageBase;
type ApiarchiveConnectionMutationParams = Parameters<typeof sqAgentsApi.archiveConnection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.archiveConnection>;

export function useApiArchiveConnectionMutation(
  options?: Omit<UseMutationOptions<ApiArchiveConnectionResponse, AxiosError<SeeqErrorData>,
    ApiarchiveConnectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveConnectionResponse, AxiosError<SeeqErrorData>,
  ApiarchiveConnectionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveConnectionMutationParams) =>
      sqAgentsApi.archiveConnection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveConnectorResponse = models.StatusMessageBase;
type ApiarchiveConnectorMutationParams = Parameters<typeof sqAgentsApi.archiveConnector> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.archiveConnector>;

export function useApiArchiveConnectorMutation(
  options?: Omit<UseMutationOptions<ApiArchiveConnectorResponse, AxiosError<SeeqErrorData>,
    ApiarchiveConnectorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveConnectorResponse, AxiosError<SeeqErrorData>,
  ApiarchiveConnectorMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveConnectorMutationParams) =>
      sqAgentsApi.archiveConnector(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiConfiguredDirectivesResponse = models.ConfiguredDirectivesOutputV1;
export function ConfiguredDirectivesQueryKey(
) {
  return ['sqAgentsApi', 'configuredDirectives'] as const;
}

export function useApiConfiguredDirectivesQuery(
  options?: Omit<UseQueryOptions<ApiConfiguredDirectivesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiConfiguredDirectivesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ConfiguredDirectivesQueryKey(),
    queryFn: () =>
      sqAgentsApi.configuredDirectives(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiCreateOrUpdateAgentResponse = models.AgentOutputV1;
type ApicreateOrUpdateAgentMutationParams = Parameters<typeof sqAgentsApi.createOrUpdateAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.createOrUpdateAgent>;

export function useApiCreateOrUpdateAgentMutation(
  options?: Omit<UseMutationOptions<ApiCreateOrUpdateAgentResponse, AxiosError<SeeqErrorData>,
    ApicreateOrUpdateAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateOrUpdateAgentResponse, AxiosError<SeeqErrorData>,
  ApicreateOrUpdateAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateOrUpdateAgentMutationParams) =>
      sqAgentsApi.createOrUpdateAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateOrUpdateConnectionResponse = models.ConnectionOutputV1;
type ApicreateOrUpdateConnectionMutationParams = Parameters<typeof sqAgentsApi.createOrUpdateConnection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.createOrUpdateConnection>;

export function useApiCreateOrUpdateConnectionMutation(
  options?: Omit<UseMutationOptions<ApiCreateOrUpdateConnectionResponse, AxiosError<SeeqErrorData>,
    ApicreateOrUpdateConnectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateOrUpdateConnectionResponse, AxiosError<SeeqErrorData>,
  ApicreateOrUpdateConnectionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateOrUpdateConnectionMutationParams) =>
      sqAgentsApi.createOrUpdateConnection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateOrUpdateConnectorResponse = models.ConnectorOutputV1;
type ApicreateOrUpdateConnectorMutationParams = Parameters<typeof sqAgentsApi.createOrUpdateConnector> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.createOrUpdateConnector>;

export function useApiCreateOrUpdateConnectorMutation(
  options?: Omit<UseMutationOptions<ApiCreateOrUpdateConnectorResponse, AxiosError<SeeqErrorData>,
    ApicreateOrUpdateConnectorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateOrUpdateConnectorResponse, AxiosError<SeeqErrorData>,
  ApicreateOrUpdateConnectorMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateOrUpdateConnectorMutationParams) =>
      sqAgentsApi.createOrUpdateConnector(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteSecretForConnectionResponse = models.StatusMessageBase;
type ApideleteSecretForConnectionMutationParams = Parameters<typeof sqAgentsApi.deleteSecretForConnection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.deleteSecretForConnection>;

export function useApiDeleteSecretForConnectionMutation(
  options?: Omit<UseMutationOptions<ApiDeleteSecretForConnectionResponse, AxiosError<SeeqErrorData>,
    ApideleteSecretForConnectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteSecretForConnectionResponse, AxiosError<SeeqErrorData>,
  ApideleteSecretForConnectionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteSecretForConnectionMutationParams) =>
      sqAgentsApi.deleteSecretForConnection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAgentResponse = models.AgentOutputV1;
export function GetAgentQueryKey(
  params: Parameters<typeof sqAgentsApi.getAgent>[0],
) {
  return ['sqAgentsApi', 'getAgent', params] as const;
}

export function useApiGetAgentQuery(
  params: Parameters<typeof sqAgentsApi.getAgent>[0],
  options?: Omit<UseQueryOptions<ApiGetAgentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAgentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAgentQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getAgent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAgentStatusResponse = Array<models.AgentStatusV1>;
export function GetAgentStatusQueryKey(
) {
  return ['sqAgentsApi', 'getAgentStatus'] as const;
}

export function useApiGetAgentStatusQuery(
  options?: Omit<UseQueryOptions<ApiGetAgentStatusResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAgentStatusResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAgentStatusQueryKey(),
    queryFn: () =>
      sqAgentsApi.getAgentStatus(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConnectionResponse = models.ConnectionOutputV1;
export function GetConnectionQueryKey(
  params: Parameters<typeof sqAgentsApi.getConnection>[0],
) {
  return ['sqAgentsApi', 'getConnection', params] as const;
}

export function useApiGetConnectionQuery(
  params: Parameters<typeof sqAgentsApi.getConnection>[0],
  options?: Omit<UseQueryOptions<ApiGetConnectionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConnectionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConnectionQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getConnection(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConnectionsResponse = models.ConnectionsOutputV1;
export function GetConnectionsQueryKey(
  params: Parameters<typeof sqAgentsApi.getConnections>[0],
) {
  return ['sqAgentsApi', 'getConnections', params] as const;
}

export function useApiGetConnectionsQuery(
  params: Parameters<typeof sqAgentsApi.getConnections>[0],
  options?: Omit<UseQueryOptions<ApiGetConnectionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConnectionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConnectionsQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getConnections(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConnectorResponse = models.ConnectorOutputV1;
export function GetConnectorQueryKey(
  params: Parameters<typeof sqAgentsApi.getConnector>[0],
) {
  return ['sqAgentsApi', 'getConnector', params] as const;
}

export function useApiGetConnectorQuery(
  params: Parameters<typeof sqAgentsApi.getConnector>[0],
  options?: Omit<UseQueryOptions<ApiGetConnectorResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConnectorResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConnectorQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getConnector(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConnectorsResponse = models.ConnectorsOutputV1;
export function GetConnectorsQueryKey(
  params: Parameters<typeof sqAgentsApi.getConnectors>[0],
) {
  return ['sqAgentsApi', 'getConnectors', params] as const;
}

export function useApiGetConnectorsQuery(
  params: Parameters<typeof sqAgentsApi.getConnectors>[0],
  options?: Omit<UseQueryOptions<ApiGetConnectorsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConnectorsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConnectorsQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getConnectors(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDatasourcesStatusResponse = models.DatasourcesStatusOutputV1;
export function GetDatasourcesStatusQueryKey(
) {
  return ['sqAgentsApi', 'getDatasourcesStatus'] as const;
}

export function useApiGetDatasourcesStatusQuery(
  options?: Omit<UseQueryOptions<ApiGetDatasourcesStatusResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDatasourcesStatusResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDatasourcesStatusQueryKey(),
    queryFn: () =>
      sqAgentsApi.getDatasourcesStatus(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetRemoteUpdateDirectivesResponse = models.RemoteAgentDirectivesOutputV1;
export function GetRemoteUpdateDirectivesQueryKey(
  params: Parameters<typeof sqAgentsApi.getRemoteUpdateDirectives>[0],
) {
  return ['sqAgentsApi', 'getRemoteUpdateDirectives', params] as const;
}

export function useApiGetRemoteUpdateDirectivesQuery(
  params: Parameters<typeof sqAgentsApi.getRemoteUpdateDirectives>[0],
  options?: Omit<UseQueryOptions<ApiGetRemoteUpdateDirectivesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetRemoteUpdateDirectivesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetRemoteUpdateDirectivesQueryKey(params),
    queryFn: () =>
      sqAgentsApi.getRemoteUpdateDirectives(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiIndexResponse = models.StatusMessageBase;
type ApiindexMutationParams = Parameters<typeof sqAgentsApi.index> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.index>;

export function useApiIndexMutation(
  options?: Omit<UseMutationOptions<ApiIndexResponse, AxiosError<SeeqErrorData>,
    ApiindexMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiIndexResponse, AxiosError<SeeqErrorData>,
  ApiindexMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiindexMutationParams) =>
      sqAgentsApi.index(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPostAgentStatusResponse = models.StatusMessageBase;
type ApipostAgentStatusMutationParams = Parameters<typeof sqAgentsApi.postAgentStatus> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.postAgentStatus>;
type ApipostAgentStatusMutationVariables = models.AgentStatusV1;

export function useApiPostAgentStatusMutation(
  options?: Omit<UseMutationOptions<ApiPostAgentStatusResponse, AxiosError<SeeqErrorData>,
    ApipostAgentStatusMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPostAgentStatusResponse, AxiosError<SeeqErrorData>,
  ApipostAgentStatusMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApipostAgentStatusMutationVariables) =>
      sqAgentsApi.postAgentStatus(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiPreProvisionResponse = models.PreProvisionOutputV1;
type ApipreProvisionMutationParams = Parameters<typeof sqAgentsApi.preProvision> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.preProvision>;
type ApipreProvisionMutationVariables = models.PreProvisionInputV1;

export function useApiPreProvisionMutation(
  options?: Omit<UseMutationOptions<ApiPreProvisionResponse, AxiosError<SeeqErrorData>,
    ApipreProvisionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPreProvisionResponse, AxiosError<SeeqErrorData>,
  ApipreProvisionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApipreProvisionMutationVariables) =>
      sqAgentsApi.preProvision(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiProvisionResponse = models.StatusMessageBase;
type ApiprovisionMutationParams = Parameters<typeof sqAgentsApi.provision> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.provision>;
type ApiprovisionMutationVariables = models.ProvisionInputV1;

export function useApiProvisionMutation(
  options?: Omit<UseMutationOptions<ApiProvisionResponse, AxiosError<SeeqErrorData>,
    ApiprovisionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiProvisionResponse, AxiosError<SeeqErrorData>,
  ApiprovisionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiprovisionMutationVariables) =>
      sqAgentsApi.provision(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiRestartAgentResponse = models.StatusMessageBase;
type ApirestartAgentMutationParams = Parameters<typeof sqAgentsApi.restartAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.restartAgent>;

export function useApiRestartAgentMutation(
  options?: Omit<UseMutationOptions<ApiRestartAgentResponse, AxiosError<SeeqErrorData>,
    ApirestartAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRestartAgentResponse, AxiosError<SeeqErrorData>,
  ApirestartAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApirestartAgentMutationParams) =>
      sqAgentsApi.restartAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRestartConnectorResponse = models.StatusMessageBase;
type ApirestartConnectorMutationParams = Parameters<typeof sqAgentsApi.restartConnector> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.restartConnector>;

export function useApiRestartConnectorMutation(
  options?: Omit<UseMutationOptions<ApiRestartConnectorResponse, AxiosError<SeeqErrorData>,
    ApirestartConnectorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRestartConnectorResponse, AxiosError<SeeqErrorData>,
  ApirestartConnectorMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApirestartConnectorMutationParams) =>
      sqAgentsApi.restartConnector(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiStoreSecretForConnectionResponse = models.StatusMessageBase;
type ApistoreSecretForConnectionMutationParams = Parameters<typeof sqAgentsApi.storeSecretForConnection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.storeSecretForConnection>;

export function useApiStoreSecretForConnectionMutation(
  options?: Omit<UseMutationOptions<ApiStoreSecretForConnectionResponse, AxiosError<SeeqErrorData>,
    ApistoreSecretForConnectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiStoreSecretForConnectionResponse, AxiosError<SeeqErrorData>,
  ApistoreSecretForConnectionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApistoreSecretForConnectionMutationParams) =>
      sqAgentsApi.storeSecretForConnection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateDirectiveResponse = models.StatusMessageBase;
type ApiupdateDirectiveMutationParams = Parameters<typeof sqAgentsApi.updateDirective> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.updateDirective>;
type ApiupdateDirectiveMutationVariables = models.DirectiveInputV1;

export function useApiUpdateDirectiveMutation(
  options?: Omit<UseMutationOptions<ApiUpdateDirectiveResponse, AxiosError<SeeqErrorData>,
    ApiupdateDirectiveMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateDirectiveResponse, AxiosError<SeeqErrorData>,
  ApiupdateDirectiveMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiupdateDirectiveMutationVariables) =>
      sqAgentsApi.updateDirective(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUpdateRemoteAgentStatusResponse = models.RemoteAgentStatusOutputV1;
type ApiupdateRemoteAgentStatusMutationParams = Parameters<typeof sqAgentsApi.updateRemoteAgentStatus> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAgentsApi.updateRemoteAgentStatus>;

export function useApiUpdateRemoteAgentStatusMutation(
  options?: Omit<UseMutationOptions<ApiUpdateRemoteAgentStatusResponse, AxiosError<SeeqErrorData>,
    ApiupdateRemoteAgentStatusMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateRemoteAgentStatusResponse, AxiosError<SeeqErrorData>,
  ApiupdateRemoteAgentStatusMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateRemoteAgentStatusMutationParams) =>
      sqAgentsApi.updateRemoteAgentStatus(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
